<template>
    <div style="height: 100%">
        <b-tabs id="tabsRsaAccettazioneEdit" ref="tabsRsaAccettazioneEdit" v-model="activeTabIndex"
            nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab"
            style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
            <b-tab id="tbAnagrafica" title="Anagrafica">
                <div class="sa-tab-scroll">
                    <rsa-accettazione-anagrafica-component ref="cmpRsaAccettazioneAnagrafica" :jsonData="jsonData"
                        :id="id"></rsa-accettazione-anagrafica-component>
                </div>
            </b-tab>
            <!-- <b-tab v-if="jsonData.regime === 'AMBULATORIALE'" id="tbRsaSchedaPaziente" title="Scheda Paziente"
                :disabled="isTabDisabled">
                <rsa-scheda-paziente-edit-component ref="cmpRsaSchedaPazienteEdit"></rsa-scheda-paziente-edit-component>
            </b-tab> -->
            <b-tab id="tbRsaPersoneRiferimento" title="Persona di Riferimento" :disabled="isTabDisabled">
                <rsa-persona-riferimento-component ref="RsaPersonaRiferimentoComponent"
                    :jsonData="jsonData"></rsa-persona-riferimento-component>
                <!-- <rsa-persona-riferimento-component ref="RsaPersonaRiferimentoComponent" @updateListaFamiliari="onUpdateListaFamiliari"></rsa-persona-riferimento-component> -->
            </b-tab>
            <b-tab id="tbRsaImpegnativa" title="Impegnativa (U.V.I.)"
                v-if="enableRsaImpegnativa || (protocolloAdi && jsonData.regime !== 'DOMICILIARE')"
                :disabled="isTabDisabled">
                <rsa-accettazione-impegnativa-list-component ref="cmpRsaAccettazioneImpegnativaList"
                    :idAccettazione="id" :jsonData="jsonData" :isViewMode="false" />
            </b-tab>
            <b-tab id="tbRsaAdiProtocolli" title="Protocolli ADI"
                v-if="protocolloAdi && jsonData.regime === 'DOMICILIARE'" :disabled="isTabDisabled">
                <rsa-adi-protocolli-list-component ref="cmpRsaAdiProtcolliList"></rsa-adi-protocolli-list-component>
            </b-tab>
            <b-tab id="tbSpesaExtra" title="Spese Extra" :disabled="isTabDisabled">
                <rsa-spesa-extra-list-component :jsonDataAccettazione="jsonData"
                    ref="cmpRsaSpesaExtraListComponent"></rsa-spesa-extra-list-component>
            </b-tab>

            <b-tab id="tbValutazioneIngresso" title="Valutazione All'Ingresso" :disabled="isTabDisabled">
                <rsa-paziente-valutazione-ingresso-list-component
                    ref="cmpRsaPazienteValutazioneIngresso"></rsa-paziente-valutazione-ingresso-list-component>
            </b-tab>

            <b-tab id="tbRsaRicette" title="Ricette" v-if="tbRsaRicette" :disabled="isTabDisabled">
                <rsa-accettazione-ricette-list-component ref="RsaAccettazioneRicetteListComponent" :idAccettazione="id"
                    :jsonData="jsonData"></rsa-accettazione-ricette-list-component>
            </b-tab>

            <b-tab id="tbRsaEsenzioni" title="Esenzioni" v-if="tbRsaEsenzioni" :disabled="isTabDisabled">
                <!-- <rsa-esenzioni-component @onModalClose="onModalClose"></rsa-esenzioni-component> -->
            </b-tab>

            <b-tab id="tbSchedeValutazione" title="Scale Valutazione" :disabled="isTabDisabled"
                v-if="tbRsaScaleValutazione">
                <rsa-accettazione-schede-valutazione-component
                    ref="RsaAccettazioneSchedeValutazioneComponent"></rsa-accettazione-schede-valutazione-component>
            </b-tab>

            <b-tab id="tbDatiFatturazione" title="Dati di Fatturazione" v-if="tbDatiFatturazione"
                :disabled="isTabDisabled">
                <rsa-accettazione-dati-fatturazione-list-component
                    ref="cmpRsaAccettazioneDatiFatturazioneComponent"></rsa-accettazione-dati-fatturazione-list-component>
            </b-tab>
            <b-tab id="tbConsensi" title="Consensi" :disabled="isTabDisabled">
                <accettazione-consensi-list-component
                    ref="cmpRsaAccettazioneConsensiList"></accettazione-consensi-list-component>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import axios from "axios";
import RsaPersonaRiferimentoComponent from "../../components/RsaPersonaRiferimentoComponent.vue";
import RsaAccettazioneAnagraficaComponent from "./RsaAccettazioneAnagraficaComponent.vue";
import RsaAccettazioneSchedeValutazioneComponent from "./RsaAccettazioneSchedeValutazioneComponent.vue";
import RsaAccettazioneRicetteListComponent from "./RsaAccettazioneRicetteListComponent.vue";
import RsaAccettazioneImpegnativaListComponent from "./RsaAccettazioneImpegnativaListComponent.vue";
import RsaAccettazioneDatiFatturazioneListComponent from "./RsaAccettazioneDatiFatturazioneListComponent.vue";
import RsaSpesaExtraListComponent from "./RsaSpesaExtraListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneConsensiListComponent from "../../../accettazione/components/AccettazioneConsensiListComponent.vue";
import RsaPazienteValutazioneIngressoListComponent from "../../rsapaziente/components/RsaPazienteValutazioneIngressoListComponent.vue";
// import RsaSchedaPazienteEditComponent from "./RsaSchedaPazienteEditComponent.vue";
import RsaAdiProtocolliListComponent from "../../rsagestionepazientiadi/components/RsaAdiProtocolliListComponent.vue";
export default {
    props: {
        // id: { type: String },
    },
    components: {
        RsaSpesaExtraListComponent,
        RsaPersonaRiferimentoComponent,
        RsaAccettazioneAnagraficaComponent,
        RsaAccettazioneSchedeValutazioneComponent,
        RsaAccettazioneRicetteListComponent,
        RsaAccettazioneImpegnativaListComponent,
        RsaAccettazioneDatiFatturazioneListComponent,
        AccettazioneConsensiListComponent,
        RsaPazienteValutazioneIngressoListComponent,
        // RsaSchedaPazienteEditComponent,
        RsaAdiProtocolliListComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/rsaaccettazioni",
            tbRsaScaleValutazione: false,
            activeTabIndex: 0,
            isTabDisabled: null,
            tbDatiFatturazione: true,
            tbRsaRicette: false,
            // tbRsaImpegnativa: false,
            tbRsaEsenzioni: false,
            tbValutazioneIngresso: false,
            id: null,
            jsonData: {
                codiceStruttura: null, //non a video
                idPresidio: null, //non a video
                numero: "", //non a video
                note: null, //non a video
                regime: null, //non a video
                settingCodice: null,
                settingDescrizione: "",
                idPrenotazione: null, //non a video
                idSettingLivello: null,
                /* nonAutonomo: null, */
                /* decretoInvalidita: null,
                strutturaProvenienza: null,
                titoloStudio: null,
                documentoTipo: null,
                documentoNumero: "",
                documentoDataRilascio: null,
                documentoDataScadenza: null, */
                accettazionePresidio: { denominazione: "" },
                accettazioneStruttura: {}, //non a video
                accettazioneAnagrafica: {
                    idAccettazione: null, //non a video
                    tipo: null, //non a video
                    identificativo: null,
                    tipoIdentificativo: "CF", //non a video
                    cognome: null,
                    nome: null,
                    dataNascita: null,
                    provinciaNascita: null,
                    comuneNascitaCodiceIstat: null,
                    sesso: null,
                    regioneResidenza: null,
                    provinciaResidenza: null,
                    comuneResidenzaCodiceIstat: null,
                    indirizzoResidenza: null,
                    capResidenza: null,
                    regioneDomicilio: null,
                    provinciaDomicilio: null,
                    comuneDomicilioCodiceIstat: null,
                    indirizzoDomicilio: null,
                    capDomicilio: null,
                    note: null,
                    medicoCurante: "",
                    codiceFiscaleMedicoCurante: null, //non a video
                    telefono: "",
                    email: "",
                    emailMedicoCurante: "",
                    medicoCuranteTelefono: "",
                    provenienzaPaziente: null,
                    tipologiaPaziente: null,
                    provenienzaRichiesta: null,
                    strutturaProvenienza: null,
                    codiceStrutturaProvenienzaReparto: null,
                },
                accettazioneStati: [],
                accettazionePrestazioni: [],
                accettazioniAsl: { aslDomicilioAmbito: null, aslResidenzaAmbito: null },
            },
            protocolloAdi: this.appConfig.protocolloAdi,
            enableRsaImpegnativa: this.appConfig.enableRsaImpegnativa,
        };
    },
    computed: {
        // isTabDisabled() {
        //   let me = this;
        //   console.log(me.id);
        //   return me.id === "-1";
        // },
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id ? this.$route.params.id : this.$router.query.idAccettazione;
        // me.enableRsaImpegnativa = this.appConfig.enableRsaImpegnativa ? this.appConfig.enableRsaImpegnativa : false;
        this.$nextTick(() => {
            let savedTabId = sessionStorage.getItem("tabRsaAccettazione");
            console.log(savedTabId);

            if (savedTabId) {
                let allTabs = this.$refs.tabsRsaAccettazioneEdit.getTabs();
                console.log(allTabs);

                let foundIndex = allTabs.findIndex((tab) => tab.id === savedTabId);
                if (foundIndex !== -1) {
                    this.activeTabIndex = foundIndex;
                }
            }
        });
        //  me.loadDataSettingLivelliAccettazione();

        // me.loadSettingsPresidi();
        // me.loadProvince();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
            immediate: true,
        },
        // id() {
        //     let me = this;
        //     me.loadData();
        // },
    },
    methods: {
        setJsonData(jsonData) {
            this.jsonData = jsonData;
        },
        activeTab(idActiveTab) {
            let me = this;
            switch (idActiveTab) {
                case "tbAnagrafica":
                    me.$refs.cmpRsaAccettazioneAnagrafica.init();
                    break;
                case "tbDatiFatturazione":
                    me.$refs.cmpRsaAccettazioneDatiFatturazioneComponent.init(me.jsonData);
                    break;
                // case "tbSpesaExtra":
                //   me.$refs.cmpRsaSpesaExtraListComponent.loadData(me.jsonData);
                //   break;
                case "tbValutazioneIngresso":
                    me.$refs.cmpRsaPazienteValutazioneIngresso.init(me.id);
                    break;
                case "tbSpesaExtra":
                    me.$refs.cmpRsaSpesaExtraListComponent.setId(me.jsonData.id);
                    break;
                case "tbRsaImpegnativa":
                    me.$refs.cmpRsaAccettazioneImpegnativaList.loadData();
                    break;
                case "tbConsensi":
                    me.$refs.cmpRsaAccettazioneConsensiList.setDati(me.id, this.jsonData, "NURITY");
                    break;
                case "tbRsaSchedaPaziente":
                    me.$refs.cmpRsaSchedaPazienteEdit.init(me.jsonData);
                    break;
                case "tbRsaPersoneRiferimento":
                    me.$refs.RsaPersonaRiferimentoComponent.init(me.id);
                    break;
                case "tbRsaAdiProtocolli":
                    me.$refs.cmpRsaAdiProtcolliList.loadData(this.jsonData);
                    break;
            }
            this.$emit("onActiveTab", idActiveTab);
        },

        loadData() {
            let me = this;
            // me.$emit("beforeLoadData");
            // me.enableRsaImpegnativa = this.appConfig.enableRsaImpegnativa ? this.this.appConfig.enableRsaImpegnativa : false;
            if (me.id === "-1" || me.id === undefined) {
                // me.$emit("afterLoadData");
                me.isTabDisabled = true;
            } else {
                me.showModalLoading = true;
                me.isTabDisabled = false;
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios
                    .get(link + me.id)
                    .then((response) => {
                        me.jsonData = response.data.data;
                        me.$nextTick(() => {
                            me.$refs.cmpRsaAccettazioneAnagrafica.init();
                        });
                        me.$emit("afterLoadData");
                    })
                    .catch(() => { });
            }
        },
        initAccettazione(jsonDataAccettazione) {
            let me = this;
            me.jsonData = jsonDataAccettazione;
            me.isTabDisabled = true;
            me.id = jsonDataAccettazione.id;
            me.loadData();
        },
        onInputTabs(index) {
            let me = this;
            let activeTab = this.$refs.tabsRsaAccettazioneEdit.getTabs()[index];
            if (activeTab && activeTab.id) {
                sessionStorage.setItem("tabRsaAccettazione", activeTab.id);
                me.activeTab(activeTab.id);
            }
            me.activeTab(activeTab.id);
        },

        onNuovaPersonaRiferimento() {
            let me = this;
            me.$refs.RsaPersonaRiferimentoComponent.onNuovaPersonaRiferimento();
        },
        loadDataPersoneRiferimento() {
            let me = this;
            me.$refs.RsaPersonaRiferimentoComponent.loadData();
        },
        loadDataSchedeValutazione() {
            let me = this;
            me.$refs.RsaAccettazioneSchedeValutazioneComponent.init(me.jsonData.id);
        },
        loadDataRicette() {
            let me = this;
            me.$refs.RsaAccettazioneRicetteListComponent.loadData();
        },
        setDatiFatturazione() {
            let me = this;
            me.$refs.RsaAccettazioneDatiFatturazioneComponent.setData();
        },
        // setDataImpegnativa() {
        //   let me = this;
        //   me.$refs.RsaAccettazioneImpegnativaListComponent.setData();
        // },
        onNuovaRicetta() {
            let me = this;
            me.$refs.RsaAccettazioneRicetteListComponent.nuovaRicetta();
        },
        onNuoviDatiFatturazione() {
            let me = this;
            me.$refs.cmpRsaAccettazioneDatiFatturazioneComponent.nuoviDatiFatturazione();
        },
        onNuovaImpegnativa() {
            let me = this;
            me.$refs.cmpRsaAccettazioneImpegnativaList.nuovaImpegnativa();
        },
        onNuovoAllegatoA() {
            let me = this;
            me.$refs.cmpRsaAccettazioneSchedaValutazioneAllegatoAComponent.salvaAllegato();
        },
        salvaSchedaPaziente() {
            let me = this;
            me.$refs.cmpRsaSchedaPazienteEdit.salva();
        },
    },
};
</script>
<style scoped>
.sa-tab-scrol {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 5px 10px 35px 10px;
}
</style>
